import React, { Component } from 'react';
import axios from 'axios';
import Header from '../Header';
import { Accordion, Card } from "react-bootstrap";
import parse from 'html-react-parser';
import LoadingScreen from '../common/loading-screen';
import TableHeaderBenefits from '../common/table-header';
// import PDF
import tncPDF from '../../assets/accor-plus-digital-vouchers-faqs.pdf'

import { NEW_DBS_BENEFITS, DBS_BENEFITS, DBS_LEAD_EMAIL_CHECK } from '../../constants/index';
import { validEmail, getUrl, validFromOctober2025, validUntilSeptember2025 } from '../helper';

import '../../css/style.css';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email : '',
            errorMessage : '',
            emailValid : true,
            loading      : false
        }

        this.handleChange   = this.handleChange.bind(this);
        this.handelClick   = this.handelClick.bind(this);
    }
        
    handleChange = (e) => {
        this.setState({
            email        : e.target.value,
            emailValid   : true,
            errorMessage : ''
        });
    };

    handelClick = () => {
        this.setState({ loading : true });
        if(!this.state.email){
            this.setState({ 
                loading      : false,
                emailValid   : false,
                errorMessage : 'Email Address is required.'
            });
            return;
        }
        if(!validEmail(this.state.email)){
            this.setState({ 
                loading      : false,
                emailValid   : false,
                errorMessage : 'Email Address not Valid.'});
            return;
        }
        axios.post(`${DBS_LEAD_EMAIL_CHECK}`,{
            email : this.state.email
            })
            .then(response => {
                console.log('response', response.data);
                if (response.status === 200) {
                    if(response.data.coupon_code){
                        const urlRoot = getUrl().urlRoot;
                        const bc = getUrl().dbs_bc;
                        //const url =  urlRoot + "sg/registration?redirect=F&bc="+bc+"&email="+this.state.email+"&coupon="+response.data.coupon_code;
                        const url = urlRoot + `partner/dbs/?couponCode=${response.data.coupon_code}`;
                        console.log("URL", url);
                        window.location.href = url;
                    } else {
                        console.log('Error fetching code', response)
                        
                        this.setState({
                            errorMessage: "ErrorCode (1048): This coupon code has been used. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance."
                        })
                    }
                    this.setState({ loading : false });
                } 
            }).catch(error => {
                let message = '';
                console.log('error.response.status',error.response.status);
                if(error.response.status){
                    switch(error.response.status){
                        case 400:
                            message = "We can't seem to proceed…<br/>Our record shows that the email address provided is not valid. Register for DBS Vantage Visa Infinite Card - ALL Accor+ Explorer membership <a href='https://dbswebprv-sg-p02.corp.dbs.com/flp-contact/dbs/cards/dbs-vantage-accor-registration/default.page' target='_blank'>here.</a>";
                            break;
                        case 401:
                            message = "We can't seem to proceed…<br/>Please contact our Member Services team at <a href='mailto:members.singapore@accorplus.com' target='_blank'>members.singapore@accorplus.com</a> for further assistance.";
                            break;
                        case 402:
                            message = "We can't seem to proceed…<br/>Our record shows that you have registered for your complimentary ALL Accor+ Explorer membership. If you require further assistance, please contact our Member Services team at <a href='mailto:members.singapore@accorplus.com' target='_blank'>members.singapore@accorplus.com</a>";
                            break;
                        default:
                            message = error.response.data.error;
                            break;
                    }
                }else{
                    message = "Oops! Something went wrong. Please try again later";
                }
                this.setState({ 
                    emailValid   : false,
                    errorMessage : message,
                    loading      : false
                });
        });
    };

    render() {
        const { errorMessage, emailValid, loading } = this.state;
        let new_benefits;
        if (NEW_DBS_BENEFITS) {
            new_benefits = NEW_DBS_BENEFITS.map((item, index) =>
                <Card key={index} className="benefits">
                    <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                        <div className="row d-flex ">
                            <div className="mb-0 col-10 col-md-11 accordion-title-text">
                                {item.title}
                            </div>
                            <div className="mb-0 col-2 col-md-1">
                                <img alt="plus-symbol" src="/images/plus-symbol.png" width="22" />
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                            <div className="row">
                                <div className="col-12">
                                    {parse(item.description)}
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            );
        };

        var errrorClass = "";
        if (!emailValid) {
            errrorClass = "validation-error"
        }
        return (
            <div class="hotelSales-wrapper">
                <Header 
                    handleLeaderBoard = {this.handleLeaderBoard}
                    bannerClass = "banner-dbs"/> 
                <div className="container">
                    <div class="mt-5 container">
                        <h2>Redeem your complimentary ALL Accor+ Explorer membership</h2>
                        <p>As a DBS Vantage Cardmember, you are entitled to a 12-month ALL Accor+ Explorer membership. ALL Accor+ Explorer, Asia Pacific's most expansive travel, dining and lifestyle programme enables you to do more, in Singapore and across Asia Pacific. Enjoy exclusive member benefits at over 1,000 participating Accor hotels and resorts including international hotel brands such as Fairmont, Sofitel, Swissôtel, and more.</p>
                    </div>

                    <TableHeaderBenefits tableTitle={validFromOctober2025("ALL ACCOR+ EXPLORER BENEFITS")} />
                    <div className="container accordion-container mt-3 benefits-container mb-5">
                        <Accordion defaultActiveKey="0">
                            {new_benefits}
                        </Accordion>
                    </div>

                    <div className="container">
                        <h5 class="px-0 py-3">Enter your email address to start experiencing more!</h5>
                        <div class="py-3">
                            {!emailValid && (
                                <div class="mb-4 text-bold text-center">{parse(errorMessage)}</div>
                            )}
                            <input type="text" class={`email-check-input ${errrorClass}`} placeholder="Enter email" onChange={this.handleChange}></input>
                            <button class="email-check-input-submit btn btn-primary mt-2 button theme-primary" onClick={this.handelClick}>Submit <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M17.42 10l-6.951-6.95-1.326 1.325 4.687 4.688H2.97v1.874H13.83l-4.687 4.688 1.326 1.326L17.419 10z"></path></svg></button>
                            {loading && (
                                <LoadingScreen/>
                            )}
                        </div>
                    </div>

                    <div class="container terms_conditions mt-4">
                        <p class="title"><strong>Terms and conditions:</strong></p>
                        <p>- This offer is only applicable for eligible DBS Vantage Card as determined by DBS.</p>
                        
                        <p>- DBS Vantage Cardmembers must register their interest for their ALL Accor+ Explorer membership at <a href="https://dbs.com.sg/vantage" target="_blank" rel="noreferrer">dbs.com.sg/vantage.</a> DBS Vantage Card members will receive a welcome email from ALL Accor+ Explorer within 1 working day once their ALL Accor+ Explorer membership has been successfully registered.</p>

                        <p>- Each Principal DBS Vantage Cardmember is entitled to a 12-month ALL Accor+ Explorer per Card Year. The ALL Accor+ Explorer membership includes 2 Stay Plus complimentary nights*, and other dining and lifestyle member benefits.</p>

                        <p>- All ALL Accor+ Explorer member benefits, including 2 Stay Plus complimentary nights, will be valid per Card Year. None of the member benefits will be retroactively accrued.</p>
                       
                        <p>- *Standard terms and conditions governing the use of an ALL Accor+ Explorer membership apply. Please view the ALL Accor+ Explorer membership <a href="https://www.accorplus.com/sg/about/terms-and-conditions/">terms and conditions</a> for more details. T&C’s apply and subject to changes without prior notice</p>    
                       
                        <p>- Stay or dining exceptions may apply to the standard ALL Accor+ Explorer member benefits, please refer to the <a href="https://www.accorplus.com/sg/about/terms-and-conditions/">member benefits exception list</a> for more details.</p>

                        <p>- For any enquiries on ALL Accor+ Explorer membership, please contact the ALL Accor+ Explorer Member Services team via the <a href="https://accorplushelp.zendesk.com/hc/en-au" target="_blank" rel="noreferrer">Member Help Centre</a>.</p>    
          
                    </div>
                </div>
            </div>    
        );
    }
}

export default (Home);
